import { TreeNode } from '../types';

/**
 * Рекурсивная функция для обхода дерева
 * @param trees деревья
 * @param callback коллбэк, который будет вызван на каждом элементе дерева.
 * Возвращаемое этой функцией значение будет передано дочерним компонентам
 */
export function traverseTreeChildren<T>(trees: TreeNode[], callback: (item: TreeNode, prevValue?: T) => T): void {
    _traverseTreeChildren(trees, callback);
}

function _traverseTreeChildren<T>(
    trees: TreeNode[],
    callback: (item: TreeNode, prevValue?: T) => T,
    previousReturnedValue?: T,
    depthLimit = 300,
) {
    if (depthLimit-- <= 0) {
        console.error(new Error('Превышена глубина дерева или в дереве есть циклические ссылки'));
        return;
    }

    trees.forEach(child => {
        const returnedValue = callback(child, previousReturnedValue);
        if (child.children) {
            _traverseTreeChildren(child.children, callback, returnedValue, depthLimit);
        }
    });
}
